import { useEffect, useRef, useState } from "react";
import { ImgDown } from "./Images/ImgDown";
import { ImgUp } from "./Images/ImgUp";
import { ThinkingIndicator } from "./ThinkingIndicator";

export const CollapsibleThink: React.FC<{ children: React.ReactNode, text: string, className?: string, additionalContent?: React.ReactNode, isAnimating?: boolean }> = ({ children, text, className, additionalContent, isAnimating }) => {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const prevChildrenRef = useRef<React.ReactNode>(children);

  // Auto-scroll to bottom when content changes during animation
  useEffect(() => {
    if (isAnimating && open && contentRef.current) {
      // Check if content actually changed
      if (children !== prevChildrenRef.current) {
        contentRef.current.scrollTop = contentRef.current.scrollHeight;
      }
      prevChildrenRef.current = children;
    }
  }, [children, isAnimating, open]);

  return (
    <div className={`think-block ${className ?? ''} ${open ? 'open' : ''}`}>
      <button onClick={() => setOpen(!open)} className="think-toggle">
        {isAnimating && <ThinkingIndicator>{text}</ThinkingIndicator>}
        {!isAnimating && <>{text}</>}
        {open ? <ImgUp /> : <ImgDown />} {additionalContent}
      </button>
      {open && <div ref={contentRef} className="think-content">{children}</div>}
    </div>
  );
};